/**
 * Waiting on subtasks, drawn as stripes of the waiting colour (spec 153
 * FR-012).
 *
 * A lighter waiting fill failed 3:1 against the card and, in dark mode, could
 * not be told from "waiting on you" at all. Stripes keep the waiting role's
 * colour, so the state still reads as waiting, and differ by pattern, so it is
 * never told apart by colour alone. The inset ring gives a small swatch its
 * edge. Tokens only, so it follows the theme.
 */
export const WAITING_ON_SUBTASKS_FILL =
  'bg-[repeating-linear-gradient(135deg,var(--color-board-state-waiting)_0_2px,transparent_2px_5px)] ring-1 ring-inset ring-board-state-waiting';
